module.exports = __webpack_public_path__ + "img/qiyeshouquanxieyi.7c62cc7e.png";